import React, { JSX } from 'react'
import * as S from './styles'

import FormBox from './FormBox'
import LanguageSwitcher from '../LanguageSwitcher'

import ImageNext from '../ImageNext'

interface LoginProps {
  id: string
  formBoxContent: JSX.Element
  formBoxFooter?: JSX.Element | null
  isResetPasswordScreen?: boolean
  isLoading: boolean
  loadingClass: string
}

const Login = ({
  id,
  formBoxContent,
  formBoxFooter,
  isResetPasswordScreen,
  isLoading,
  loadingClass
}: LoginProps) => {
  return (
    <S.LoginWrapper id={id}>
      <ImageNext
        src="/assets/images/login-image.png"
        alt="BioAtlas"
        width={660}
        height={667}
        sizes="(max-width: 1100px) 100vw, 50vw"
        className="login-illustration"
      />
      <S.LoginContainer className="flexbox">
        {!isLoading && (
          <S.LanguageSwitcherContainer>
            <LanguageSwitcher id="inp_flagselect_login" />
          </S.LanguageSwitcherContainer>
        )}
        <div
          id="formbox-container"
          className="flexbox v-centered h-centered cont100 p-0"
        >
          <FormBox
            footer={formBoxFooter}
            isLoading={isLoading}
            isResetPasswordScreen={isResetPasswordScreen}
            html={formBoxContent}
            loadingClass={loadingClass}
          />
        </div>
      </S.LoginContainer>
    </S.LoginWrapper>
  )
}

export default Login
